import React from 'react'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '' }) => (
  <span className={`spinner spinner--${size} ${className}`.trim()} role="progressbar" aria-label="Loading" />
)

/** Centered spinner + caption block for loading states. */
export const LoadingBlock: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <div className="loading-block">
    <Spinner size="lg" />
    <span>{label}</span>
  </div>
)

export default Spinner
